import React from 'react';
import LegacyDiscoverPage from './LegacyDiscoverPage';
import DiscoverCollectionsPage from './discover/DiscoverCollectionsPage';

// Build-time staging preview. Production keeps the reviewed Discover experience.
export default function DiscoverPage() {
  return process.env.REACT_APP_DISCOVER_COLLECTIONS === 'true'
    ? <DiscoverCollectionsPage /> : <LegacyDiscoverPage />;
}
